export default {
    api_host: process.env.VUE_APP_API_HOST,
    app_version: process.env.VUE_APP_VERSION,
    base_url: process.env.VUE_APP_BASE_URL,
    cookie_domain: process.env.VUE_APP_COOKIE_DOMAIN,
    desk_v1_host: process.env.VUE_APP_DESK_V1_HOST,
    desk_v2_host: process.env.VUE_APP_DESK_V2_HOST,
};
